// second added on this date: 2025-11-25

//import React, { useRef, useState, useEffect, useNavigate } from "react";
import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FaTrashAlt, FaCamera } from "react-icons/fa";
//import { useNavigate } from "react-router-dom";
import "../App.css";
import femaleAvatar from "../assets/female.png";
import maleAvatar from "../assets/male.png";

// âœ… IMPORTANT: backend URL
//const API_BASE = "http://localhost:8000";   // change if needed
const API_BASE = "http://144.91.102.67:8002"

export default function ProfileHeader(props) {
  const navigate = useNavigate();
  //const [data, setData] = useState({});
  const [image, setImage] = useState(null);
  const fileInputRef = useRef();
  const [profile, setProfile] = useState({});

  // âœ… FETCH PROFILE FROM BACKEND
  {/*useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token =
          localStorage.getItem("access_token") ||
          localStorage.getItem("token") ||
          localStorage.getItem("authToken") ||
          localStorage.getItem("jwt");

        const res = await axios.get(`${API_BASE}/api/candidate/profile`, {
          headers: token
            ? { Authorization: `Bearer ${token}` }
            : {}
        });

        const p = res.data;

        // âœ… MAP BACKEND â†’ UI
        setData({
          fullName: p.headerName,
          mobile: p.headerMobile,
          yearsOfExp: p.experience,
          qualification: p.headerQualification,
          specialization: p.headerSpecialization,
          course: p.education?.[0]?.course,
          Gender: p.gender
        });

        // âœ… SAVE PROFILE TO LOCALSTORAGE (IMPORTANT FOR APPLY BUTTON)
        localStorage.setItem(
          "ProfileHighlight",
          JSON.stringify({
            fullName: p.headerName,
            mobile: p.headerMobile,
            qualification: p.headerQualification,
            specialization: p.headerSpecialization,
            course: p.education?.[0]?.course,
            skills: p.skills,
            experience: p.experienceData,
            education: p.education,
            resume: p.resume
          })
        );
                // ➤ NEW: Set image from backend added on 4-12-2025
        if (p.profile_image) {
          const fullUrl = `${API_BASE}${p.profile_image}`;
          setImage(fullUrl);

          // 🔥 VERY IMPORTANT — store it for page refresh
          localStorage.setItem("profile_image", fullUrl);
        }

      } catch (err) {
        console.error("Profile fetch failed:", err);
      }
    };

    fetchProfile();
  }, []);*/}

  // added on 11-12-2025

  useEffect(() => {
    async function fetchProfile() {
      try {
        const token = localStorage.getItem("access_token");
        console.log("TOKEN IN PROFILE PAGE:", token);

        if (!token) {
          alert("User not logged in");
          navigate("/");
          return;
        }
        const response = await axios.get( "http://144.91.102.67:8002/api/candidate/profile",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        console.log("PROFILE RESPONSE:", response.data);
        setProfile(response.data);

      } catch (error) {
        console.error("❌ Error loading profile:", error);
        alert("Unable to load profile, please login again.");
        navigate("/");
      }
    }

    fetchProfile();
  }, []);

  // âœ… LOAD SAVED PROFILE IMAGE
  useEffect(() => {
    const savedImage = localStorage.getItem("profile_image");
    if (savedImage) setImage(savedImage);
  }, []);

  // âœ… IMAGE UPLOAD
  {/*const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result);
        localStorage.setItem("profile_image", reader.result);
      };
      reader.readAsDataURL(file);
    }
  };*/}
  // added on 4-12-2025

  // 🔥🔥 FIX: Restore saved image on refresh (this was missing)
  useEffect(() => {
    const savedImage = localStorage.getItem("profile_image");
    if (savedImage) {
      setImage(savedImage);
    }
  }, []);

  // added on 4-12-2025
  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const token = localStorage.getItem("acess_token");
      //localStorage.getItem("access_token") ||
      //localStorage.getItem("token") ||
      //localStorage.getItem("authToken") ||
      //localStorage.getItem("jwt");

    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await axios.post(
        `${API_BASE}/api/candidate/upload_profile`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // IMPORTANT: Build FULL image URL
      const fullUrl = `${API_BASE}${res.data.profile_url}`;

      // show image immediately
      setImage(fullUrl);

      // save for next reload
      localStorage.setItem("profile_image", fullUrl);

    } catch (err) {
      console.error("Upload failed:", err);
    }
  };

  // âœ… REMOVE IMAGE
  const handleRemoveImage = (e) => {
    e.stopPropagation();
    setImage(null);
    localStorage.removeItem("profile_image");
  };
  // added on 11-12-2025

  // added on 9-12-2025
  const name = profile.headerName || "Your Name";
  const experience = profile.experience || 0;
  const qualification = profile.headerQualification || "";
  const specialization = profile.headerSpecialization || "";
  const gender = profile.gender || profile.Gender || "";
  const mobile = profile.headerMobile || "";
  const course = profile.education?.[0]?.course || "";


  const score = props.score ?? 10;
  // âœ… DEFAULT AVATAR
  const defaultAvatar =
    (profile.Gender || props.Gender)?.toLowerCase() === "female"
      ? femaleAvatar
      : maleAvatar;

  // âœ… UI VALUES
  //const name = data.fullName || "Your Name";
  //const experience = data.yearsOfExp || 0;
  //const gender = data.Gender || "";
  //const mobile = data.mobile || "";

  //const qualification = data.qualification || "";
  //const course = data.course || "";
  //const specialization = data.specialization || "";

  const basicLevels = ["below 10th", "10th", "12th"];

  const showQualificationOnly =
    qualification &&
    basicLevels.includes(qualification.toLowerCase());

  const showCourseAndSpecialization =
    course && !showQualificationOnly;

  {/*const calculateProfileScore = () => {
  const profile = JSON.parse(localStorage.getItem("ProfileHighlight"));
  if (!profile) return 10;

  let total = 0;
  let completed = 0;

  const check = (val) => {
    total++;
    if (val && val.length !== 0) completed++;
  };

  check(profile.resume);
  check(profile.education);
  check(profile.skills);
  check(profile.experience);
  check(profile.projects);
  check(profile.internships);
  check(profile.languages);
  check(profile.certifications);

  return Math.round((completed / total) * 100) || 10;
};*/}

  {/*const calculateProfileScore = () => {
    const profile = JSON.parse(localStorage.getItem("ProfileHighlight"));
    if (!profile) return 10;

    let score = 10;
    if (profile.resume) score += 15;
    if (profile.education && profile.education.length > 0) score += 10;
    if (profile.skills && profile.skills.length >= 1) score += 15;
    if (profile.experience && profile.experience.length > 0) score += 10;
    if (profile.projects && profile.projects.length > 0) score += 7;
    if (profile.internships && profile.internships.length > 0) score += 10;
    if (profile.languages && profile.languages.length > 0) score += 5;
    if (profile.certifications && profile.certifications.length > 0) score += 10;

    return Math.min(100, score);
  }*/}

  // âœ… SCORE (placeholder, UI unchanged)
  //const score = props.score ?? data.score ?? 10;
  //const score = calculateProfileScore();
  //const score = calcScore(data);

  return (
    <div className={`cprofile-header ${props.variant === "sidebar" ? "cprofile-header-sidebar" : ""}`}>

      <div className="profile-left">
        <div className="avatar-ring">
          <svg className="score-ring" viewBox="0 0 36 36">
            <path className="ring-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
            <path className="ring-progress" strokeDasharray={`${score}, 100`} d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
            {/* <text x="18" y="21" className="ring-text"></text> */}
          </svg>

          <div className="avatar-wrapper" onClick={() => fileInputRef.current.click()}>
            <img src={image || defaultAvatar} alt="Profile" className="avatar-img" />

            {!image && (
              <div className="upload-overlay">
                <FaCamera className="upload-icon" />
              </div>
            )}

            {image && (
              <div className="remove-icon" onClick={handleRemoveImage}>
                <FaTrashAlt />
              </div>
            )}
          </div>

          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            onChange={handleImageUpload}
            style={{ display: "none" }}
          />
        </div>
      </div>

      <div className="profile-meta">
        <div className="metaa-name">{name}</div>

        {experience >= 1 && (
          <div className="metaa-exp">
            {experience} Year{experience > 1 ? "s" : ""} Experience
          </div>
        )}

        {showQualificationOnly && (
          <div className="metaa-sub">{qualification}</div>
        )}

        {showCourseAndSpecialization && (
          <div className="metaa-sub">
            {course}
            {specialization ? " - " + specialization : ""}
          </div>
        )}

        <div className="metaa-sub">{gender}</div>

        <div className="phonee">
          {mobile ? " 📞 " + mobile : "Mobile number not added"}
        </div>
      </div>
    </div>
  );
}

